import {
  Create,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';

export const TagCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
    </SimpleForm>
  </Create>
);
